<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "carCode": "粤A12345",
                "userName": "张三",
                "userPhone": "18000000000",
                "ticketName": "wdl190327001",
                "buyMethod": 2,
                "ticketType": 1,
                "validStatus": 0,
                "effective": 1,
                "startTime": "20190101000000",
                "endTime": "20190501000000",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "monthTicketList": [
                        {
                            "actualValue": 10,
                            "buyMethod": 2,
                            "carCode": "粤A12345",
                            "configStatus": 2,
                            "createBy": "System",
                            "createTime": "20190327141739",
                            "dynamicCarportNumber": 1,
                            "endRenewTime": "22190328000000",
                            "id": 4826,
                            "inviteCarCurrentCount": 0,
                            "isDelete": 0,
                            "monthTicketConfigId": 516,
                            "parkCodes": "2KKN885S",
                            "price": "10.00",
                            "reliefValue": 10,
                            "remark": "新增预约VIP月票",
                            "renewFormerDays": 0,
                            "renewMethod": 2,
                            "supportVirtualCarcode": 0,
                            "ticketCode": "2019032714173938670233",
                            "ticketName": "wdl190327001",
                            "ticketType": 1,
                            "timeperiodList": "20190327000000*20190328000000,20190329000000*20190331000000,20190429000000*20190501000000",
                            "topBillCode": "2019032714173950637803",
                            "totalValue": 20,
                            "updateBy": "张三",
                            "updateTime": "20190327140000",
                            "userName": "张三",
                            "userPhone": "18000000000",
                            "validStatus": 0
                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询车牌线上月票",
                t_url: this.commonUrls.test + "getOnlineMonthTicketByCarCard",
                p_url: this.commonUrls.prod + "getOnlineMonthTicketByCarCard",
                precondition: "无",
                fitSystem: "云停车场,传统停车场(线上接口开通)",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodes', info2: '否', info3: 'String', info4: '停车场编号列表，","分隔' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'userName', info2: '否', info3: 'String', info4: '车主姓名' },
                        { info1: 'userPhone', info2: '否', info3: 'String', info4: '车主电话' },
                        { info1: 'ticketName', info2: '否', info3: 'String', info4: '月票名称' },
                        { info1: 'ticketType', info2: '否', info3: 'Integer', info4: '月票类型, 0对内 1对外' },
                        { info1: 'buyMethod', info2: '否', info3: 'Integer', info4: '月票购买方式, 0后台添加 1自行购买 2第三方添加' },
                        { info1: 'validStatus', info2: '否', info3: 'Integer', info4: '付款状态, 0已付款，1已退款' },
                        { info1: 'effective', info2: '否', info3: 'Integer', info4: '生效状态, 0已生效，1已失效' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '月票购买起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '月票购买结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketList', info2: '是', info3: 'JSONArray', info4: '月票列表' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总张数' },
                    ]
                },{
                    titleName: 'monthTicketList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '月票id' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '月票流水号' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票名称' },
                        { info1: 'ticketType', info2: '是', info3: 'Integer', info4: '月票类型, 0对内 1对外' },
                        { info1: 'ticketCode', info2: '是', info3: 'Integer', info4: '月票编号' },
                        { info1: 'userName', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号，支持多个逗号分隔,展示用' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价' },
                        { info1: 'totalValue', info2: '是', info3: 'Decimal', info4: '总金额' },
                        { info1: 'actualValue', info2: '是', info3: 'Decimal', info4: '实付金额' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'refundValue', info2: '是', info3: 'Decimal', info4: '退款金额' },
                        { info1: 'availableValue', info2: '是', info3: 'Decimal', info4: '剩余可用额度' },
                        { info1: 'endRenewTime', info2: '是', info3: 'String', info4: '车主截止续费时间，yyyyMMddHHmmss' },
                        { info1: 'validStatus', info2: '是', info3: 'Integer', info4: '付款状态，0已付款，1已退款' },
                        { info1: 'createBy', info2: '是', info3: 'String', info4: '创建人' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '创建时间/购买时间，yyyyMMddHHmmss' },
                        { info1: 'updateBy', info2: '是', info3: 'String', info4: '修改操作人' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '修改操作时间，yyyyMMddHHmmss' },
                        { info1: 'inviteCarCurrentCount', info2: '是', info3: 'Integer', info4: '邀请车牌总数量' },
                        { info1: 'dynamicCarportNumber', info2: '是', info3: 'Integer', info4: '该月票开通多少车位' },
                        { info1: 'carCodeNum', info2: '是', info3: 'Integer', info4: '该月票开通的车牌数量' },
                        { info1: 'isDelete', info2: '是', info3: 'Integer', info4: '是否删除, 0 否, 1 是' },
                        { info1: 'buyMethod', info2: '是', info3: 'Integer', info4: '月票购买方式（0:后台添加;1:自行购买;2:第三方添加）' },
                        { info1: 'parkCodes', info2: '是', info3: 'String', info4: '停车场编号列表，需与线上月票类型权限的parkCodes完全一致方可创建' },
                        { info1: 'timeperiodList', info2: '是', info3: 'String', info4: '月票有效期"yyyyMMddHHmmss*yyyyMMddHHmmss,..."' },
                        { info1: 'configStatus', info2: '是', info3: 'Integer', info4: '月票状态，0未上架，1已上架' },
                        { info1: 'renewMethod', info2: '是', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义' },
                        { info1: 'renewFormerDays', info2: '是', info3: 'Integer', info4: '向前续费天数，0表示不允许向前续费，旧数据默认是0' },
                        { info1: 'inviteCarTotal', info2: '是', info3: 'Integer', info4: '允许邀请车牌的总数量' },
                        { info1: 'supportVirtualCarcode', info2: '是', info3: 'Integer', info4: '支持虚拟车牌,0=不支持，1=支持，虚拟车牌与实体车牌互斥' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'isFrozen', info2: '是', info3: 'Integer', info4: '是否冻结0否，1即将，2冻结' },
                        { info1: 'frozenTime', info2: '否', info3: 'String', info4: '冻结时间' },
                        { info1: 'resendNum', info2: '否', info3: 'Integer', info4: '重发次数' },
                        { info1: 'syncStatus', info2: '否', info3: 'Integer', info4: '同步状态(0未发送，1发送中，2发送成功，3发送失败)' },
                        { info1: 'syncTime', info2: '否', info3: 'String', info4: '同步时间' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getOnlineMonthTicketByCarCard.vue